import React from "react";
import { LabelDate, LabelDollarFormatted, LabelString } from "@loanbossinc/component-library";

export const assetDataTableClosedDealColumns = [
  {
    id: "name",
    label: "Deal",
    path: "name",
    Cell: value => <LabelString value={value} />
  },
  {
    id: "lender",
    label: "Lender",
    path: "filteredDealMetric.lenderName",
    Cell: value => <LabelString value={value} />
  },
  {
    id: "balance",
    label: "Balance",
    path: "filteredDealMetric.currentBalance",
    sortAsNumber: true,
    Cell: value => (
      <LabelDollarFormatted value={value} decimals={0} />
    )
  },
  {
    id: "maturity",
    label: "Maturity",
    path: "filteredDealMetric.maturity",
    Cell: value => <LabelDate value={value} />
  }
];
